import { TreasuryRequirementBatchResponse } from "lib-klab-sdks";
import { RequirementBatch } from "../../../domain/models/treasury/payment-batch.model";

export function mapTreasuryRequirementBatch(source: TreasuryRequirementBatchResponse): RequirementBatch {
  return {
    requirementId: source.idRequirement,
    batchId: source.idPaymentBatch,
    batchCode: source.batchCode,
    batchStatus: source.batchStatus,
    itemStatus: source.itemStatus,
  };
}
